import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getFormattedSort } from "helpers";
import { getApplicationLogRequest, GetTableResponse } from "services";
import { TableGetParams, ApplicationLog, ApplicationLogFilters } from "types";

interface ApplicationLogSlices {
  data: ApplicationLog[];
  loading: boolean;
  totalCount: number;
}

export const getApplicationLog = createAsyncThunk<
  GetTableResponse<ApplicationLog>,
  TableGetParams<ApplicationLogFilters>
>("marketing/getMarketing", async (params, thunkAPI) => {
  try {
    const sort = getFormattedSort(params.sort);
    const response = await getApplicationLogRequest({ ...params, sort });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(false);
  }
});

const initialState: ApplicationLogSlices = {
  data: [],
  loading: true,
  totalCount: 0,
};

const applicationLogSlices = createSlice({
  name: "marketing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getApplicationLog.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getApplicationLog.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
      state.totalCount = action.payload.totalCount;
    });
    builder.addCase(getApplicationLog.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const { reducer: applicationLogReducer } = applicationLogSlices;
